import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchRandomQuote = createAsyncThunk(
  "quotes/fetchRandomQuote",
  async () => {
    const response = await axios.get(`${BASE_URL}/api/quotes/randomquote`);
    return response.data;
  }
);

const randomQuoteSlice = createSlice({
  name: "randomQuote",
  initialState: {
    randomQuote: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearRandomQuote: (state) => {
      state.randomQuote = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch random quote
      .addCase(fetchRandomQuote.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRandomQuote.fulfilled, (state, action) => {
        state.randomQuote = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRandomQuote.rejected, (state, action) => {
        state.fetchRandomQuote = false;
        state.error = action.error.message;
      });
  },
});

export const { clearRandomQuote } = randomQuoteSlice.actions;

export default randomQuoteSlice.reducer;
